import mixpanel from 'mixpanel-browser';
import { getMixpanelToken } from '../config';

mixpanel.init(getMixpanelToken());

export const trackEvent = (eventName, eventProperties) => {
  mixpanel.track(eventName, eventProperties);
};
